import React, { Component } from 'react'
import classnames from 'classnames';
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SECTIONS, reportActions } from '../../store/reportStore';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { isNullOrUndefined } from '../../store/storeFunctions';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Scrollspy from 'react-scrollspy';
import BbCheckbox from '../styling/bbCheckbox';
import DragDropIcon from '../../img/icons/DragAndDrop';
import ShownIcon from '../../img/icons/Zobrazeno';
import HideIcon from '../../img/icons/BBicons_Skryt';
import CrossIcon from '../../img/icons/Cross';
import SvgBBiconsRozbalitVse from '../../img/icons/BBicons_Rozbalit_vse';
import { UncontrolledTooltip  } from 'reactstrap';
import { reportNavActions } from '../../store/reportNavStore';
import { isIE } from './utils';
import './reportSectionsManager.scss';

class ReportSectionsManager extends Component {
    state = {
        currentlyFocusedSection:''
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.getVisibleSections(this.props.nav).length !== 0 && this.props.getVisibleSections(prevProps.nav).length === 0) {
            this.setState({currentlyFocusedSection: this.props.getVisibleSections()[0].id});
        }
    }

    render() {
        const visible = this.props.getVisibleSections();
        let heights = Array.prototype.slice.call(document.querySelectorAll('.content-body-wrapper > div:not(.content-body)')).map(x => x.clientHeight);
        let offset = -(heights.length === 0 ? 0 : heights.reduce((res,val) => res+val) + ((document.querySelector('#entity-row') || {}).clientHeight || 0)-20);
        if(this.props.panelIconMode) {
            return this.renderAsPanelIcons(visible, offset);
        }
        return this.renderAsPanelContent(visible, offset);
    }

    renderAsPanelContent = (visible, offset) => {
        const identDataSection = visible.find(i => i.id === SECTIONS.identData);

        return (
            <article className="panel">
                <div className="panel-heading">
                    <div className='panel-heading-title'>
                        <div style={{marginRight:'auto', marginTop:'auto', marginBottom:'auto'}}><Translate id="Report.Sections" /></div>
                        <CrossIcon className='icon-centered' onClick={this.props.closePanel} style={{marginLeft: '.5em'}} />
                    </div>
                </div>
                <div className='search-progress'></div>
                <div className="panel-block report-sections-manager">
                    <div className={classnames({ 'show-hide-all-wrapper': true,  'not-active': !this.props.nav.isSectionsMenuInEditMode })}>
                        <div className={classnames({ 'report-section-manager': true, 'show-hide-all': true })}>
                            <span style={{ fontWeight: 600 }}><Translate id="Common.ShowHideAll" /></span>
                            {this.props.nav.isSectionsMenuInEditMode && <BbCheckbox label="" id="showHide" value={this.checkBoxValue}
                                style={{ padding: "0", justifyContent: "flex-end" }} onChange={() => this.onShowHideAllChange()}
                            />}                        
                        </div>
                        <div className={classnames({ 'report-section-manager': true, 'show-hide-all': true })}>
                            <span className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal', 'hide-on-mobile': !this.props.showOnMobile })} 
                                style={{ fontWeight: 600 }} onClick={() => this.onResetOrder()}><Translate id="Common.Restore.Default.SectionOrder" /></span>
                        </div>
                    </div>
                    <Scrollspy items={visible.map(s => s.id)} componentType='div' onUpdate={this.onFocusedSectionChanged} offset={offset}>
                        {identDataSection && this.renderLockedSections(identDataSection)}
                        {this.renderDragDrop()}
                    </Scrollspy>
                    {this.renderButtons('')}
                </div>
            </article>
        );
    }

    renderAsPanelIcons = (sections, offset) => {
        return (
            <Scrollspy items={sections.map(s => s.id)} componentType='div' onUpdate={this.onFocusedSectionChanged} offset={offset}>
                <div className='right-panel-icon report-section-panel-opener' onClick={() => this.props.panelOpen()}>
                    <div className='right-panel-icon-wrapper'>
                        <div className='right-panel-icon-holder'>
                            <SvgBBiconsRozbalitVse style={{transform: 'rotateZ(90deg)', width:'1.5em', height:'1.5em'}} />
                        </div>
                    </div>
                </div>
                <PerfectScrollbar options={{suppressScrollX:true, maxScrollbarLength:100}}>
                    <div style={{display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 29em)'}}>
                        {sections.map(s => {
                            const Icon = this.props.getSectionIcon(s.id);

                            return (<div key={s.id} className={classnames('right-panel-icon', {'active':s.id === this.state.currentlyFocusedSection})}
                                onClick={() => this.onMenuSectionHeaderClicked(s)}>
                                <UncontrolledTooltip 
                                    target={`rp-tooltip-id-${s.id}`} 
                                    placement='left' 
                                    className={classnames({'rp-tooltip-ie': isIE()})}
                                    delay={{ show: 0, hide: 0 }}
                                    >{s.name}</UncontrolledTooltip>
                                <div id={`rp-tooltip-id-${s.id}`} className='right-panel-icon-wrapper'>
                                    <div className='right-panel-icon-holder'>
                                        <Icon />
                                    </div>
                                </div>
                            </div>);
                        })}
                    </div>
                </PerfectScrollbar>
            </Scrollspy>
        );
    }

    renderLockedSections = (identDataSection) => {
        return (
            <div key={identDataSection.id + '-' + identDataSection.orderId} className='draggable-container'>
                <div style={{ cursor: 'not-allowed' }}>
                    <div>
                        <div className={classnames({
                            'section-button-container': true,
                            'section-button-container-editing': this.props.nav.isSectionsMenuInEditMode
                        })}>
                            {this.renderSectionItem(identDataSection, false)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderDragDrop = () => {
        const sectionWithoutIdent = this.props.getVisibleSections().filter(section => section.id !== SECTIONS.identData);
        return (
            <DragDropContext onDragEnd={(di) => this.onDragEnd(di)}>
                <Droppable droppableId='droppable-1' type='REPORT'>
                    {(provided, _) => (<>
                        <div className="section-list" ref={provided.innerRef} {...provided.droppableProps}>
                            {sectionWithoutIdent.map((section, index) => this.renderDragableItem(section,index))}
                            {provided.placeholder}
                        </div>
                    </>)}
                </Droppable>
            </DragDropContext>
        );
    }

    renderDragableItem = (section, index) => {
        return (
            <div key={section.id + '-' + section.orderId} className='draggable-container'>
                <Draggable draggableId={section.id} index={index} isDragDisabled={!this.props.nav.isSectionsMenuInEditMode}>
                    {(provided, snapshot) => (
                        <div style={{ cursor: 'pointer' }}>
                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                <div className={classnames('section-button-container',{
                                    'section-button-container-editing': this.props.nav.isSectionsMenuInEditMode,
                                    'section-button-container-dragging': snapshot.isDragging
                                })}>
                                    {this.renderSectionItem(section, true)}
                                </div>
                            </div>
                        </div>
                    )}
                </Draggable>
            </div>
        );
    }

    renderSectionItem = (section, isDraggable) => {
        const Icon = this.props.getSectionIcon(section.id);
        return (<>
            <div className={classnames(['section-icon-wrapper', 'drag-drop-icon-wrapper'],{
                'not-active': !this.props.nav.isSectionsMenuInEditMode,
                'not-draggable': !isDraggable
            })}>
                <DragDropIcon className='size-1em drag-drop-icon' />
            </div>
            <div className='section-name-container' onClick={() => this.onMenuSectionHeaderClicked(section)} title={section.name} style={{ display: "flex", alignItems: "center" }}>
                <span className={classnames({ 'delimiting-span-1': true, 'not-active': !this.props.nav.isSectionsMenuInEditMode })} />
                <div className={classnames('section-icon-wrapper', {'active': this.state.currentlyFocusedSection === section.id})}>
                    <Icon className='svg-standard-fill' />
                    </div>
                <span className='delimiting-span-2' />
                <div className='section-header-wrapper'>
                    <h6 className={classnames('section-header', {'report-section-focused': this.state.currentlyFocusedSection === section.id})}>
                        {section.countryFilter ? <span>{section.name} <sup>{section.countryFilter}</sup></span> : section.name}
                    </h6>
                </div>
            </div>
            {this.props.nav.isSectionsMenuInEditMode && <>
                {section.id === SECTIONS.identData &&
                    <div className='visible-icon'><ShownIcon className='size-1-5em disabled-visible-icon' /></div>
                }
                {section.id !== SECTIONS.identData &&
                    <div className='visible-icon' onClick={_ => this.props.toggleShow([section.id], !section.hidden)}>
                        {section.hidden && <HideIcon className='size-1-5em svg-standard-fill' />}
                        {!section.hidden && <ShownIcon className='size-1-5em svg-standard-fill' />}
                    </div>
                }
            </>}
        </>)
    }

    renderButtons = mobileDesktopClassName =>
        <>
            {this.props.nav.isSectionsMenuInEditMode &&
                <div className={`buttons ${mobileDesktopClassName}`} style={{ paddingBottom: '.5em', justifyContent: 'center', paddingTop: "1.5em" }}>
                    <button className={classnames('bb-button small gradient-1-gray', {'is-square': localStorage.locales_button_style === 'square' })} onClick={this.onCancelInEditMode}><Translate id='Common.Button.Cancel' /></button>
                    <button className={classnames('bb-button small gradient-1', {'is-square': localStorage.locales_button_style === 'square' })} onClick={this.onSaveInEditMode}><Translate id='Common.Button.Save' /></button>
                </div>
            }
            {!this.props.nav.isSectionsMenuInEditMode &&
                <div className={`buttons ${mobileDesktopClassName}`} style={{ paddingBottom: '.5em', justifyContent: 'center', paddingTop: "1.5em" }}>
                    <button
                        className={classnames('bb-button small gradient-1', {'is-square': localStorage.locales_button_style === 'square' })}
                        onClick={this.onEditModeInitialized}>
                        <Translate id='Report.EditSections' />
                    </button>
                </div>
            }
        </>

    onDragEnd = dragInfo => {
        if (dragInfo.destination && dragInfo.reason === 'DROP' && dragInfo.source.index !== dragInfo.destination.index) {
            const identDataSection = this.props.getVisibleSections().find(i => i.id === SECTIONS.identData);

            const sections = this.reorder(
                this.props.nav.sectionMap,
                dragInfo.source.index + (identDataSection ? 1 : 0),
                dragInfo.destination.index + (identDataSection ? 1 : 0)
            );

            this.props.reorderSections(sections.every(section => section.orderId === 0) ? sections.map((section, index) => ({ ...section, orderId: index })) : sections);
        }
    };

    onResetOrder = _ => {
        this.props.resetSectionsOrder(this.props.nav.sectionMap);
    }

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        
        const ids = list.map((section) => section.orderId);
        result.forEach((section, index) => section.orderId = ids[index]);
        return result;
    };

    onEditModeInitialized = _ => {
        this.props.toggleSectionEditMode(true);
        this.props.createConfigSnapshot();
        this.props.createNavConfigSnapshot();
    }

    onSaveInEditMode = _ => {
        this.props.toggleSectionEditMode(false);
        this.props.saveSections();
    }

    onCancelInEditMode = _ => {
        this.props.toggleSectionEditMode(false);
        this.props.restoreConfig();
        this.props.restoreNavConfig();
    }

    onShowHideAllChange = _ => {
        this.checkBoxValue ? this.props.hideAllSections() : this.props.showAllSections();
    }

    onMenuSectionHeaderClicked = section => {
        if (section.hidden === false) {
            this.props.scrollToElement(this.props.nav.elements[section.id], false, this.props.scrollBehavior || 'smooth');
        }
    }

    onFocusedSectionChanged = e => {
        if (isNullOrUndefined(e)) {
            return;
        }
        this.setState({ currentlyFocusedSection: e.id });
    }

    get checkBoxValue() {
        if (!isNullOrUndefined(this.props.nav.sectionMap)) {
            let count = this.props.nav.sectionMap.filter(x => x.id !== SECTIONS.identData).length;
            let hiddenCount = this.props.nav.sectionMap.filter(x => x.hidden && x.id !== SECTIONS.identData).length;
            if (hiddenCount === 0) { return true };
            if (hiddenCount === count) { return false };
        }
        return null;
    }
}

export default connect(
    state => ({ nav: state.reportNav }),
    dispatch => bindActionCreators({...reportActions, ...reportNavActions}, dispatch)
)(ReportSectionsManager);
